/* eslint-disable no-param-reassign */
import get from 'lodash/get';
import cryptoJs from 'crypto-js';
import { action, thunk } from 'easy-peasy';
import axios, { AxiosResponse } from 'axios';
import {
  ApiModel,
  Errors,
  RequestValues,
  ResponseData,
} from 'app/state/api/interfaces';

const CONTENT_TYPE = 'application/json';

export const APIModel = <QueryModel, ResponseModel>(
  url: string
): ApiModel<QueryModel, ResponseModel> => ({
  loading: false,
  success: false,
  data: {
    count: 0,
    data: [],
    vizData: undefined,
  },
  errorData: null,
  onError: action((state, payload: Errors) => {
    state.loading = false;
    state.errorData = payload;
  }),
  onSuccess: action((state, payload: ResponseData<ResponseModel>) => {
    const { addOnData, encrypted, ed, ...actualPayload } = payload;
    state.loading = false;
    state.success = true;
    if (encrypted && ed) {
      // @ts-ignore
      state.data = JSON.parse(
        cryptoJs.AES.decrypt(
          ed.toString(),
          process.env.REACT_APP_ENCRYPTION_SECRET as string
        ).toString(cryptoJs.enc.Utf8)
      );
    } else if (addOnData) {
      // @ts-ignore
      state.data = {
        ...state.data,
        count: actualPayload.count,
        // @ts-ignore
        data: [...state.data.data, ...actualPayload.data],
      };
    } else {
      state.data = actualPayload;
    }
  }),
  setSuccess: action((state) => {
    state.loading = false;
    state.success = true;
  }),
  onRequest: action((state) => {
    state.loading = true;
    state.success = false;
  }),
  fetch: thunk(async (actions, query: RequestValues<QueryModel>) => {
    actions.onRequest();
    axios
      .post(url, query.values, {
        headers: {
          'Content-Type': CONTENT_TYPE,
        },
      })
      .then(
        (resp: AxiosResponse) =>
          actions.onSuccess({ ...resp.data, addOnData: query.addOnData }),
        (error: any) => actions.onError(error.response)
      );
  }),
  fetchGet: thunk(async (actions, query: RequestValues<QueryModel>) => {
    actions.onRequest();
    let headers: any = {
      'Content-Type': CONTENT_TYPE,
    };
    const params: any = query.values;
    if (get(query, 'values.token', '') !== '') {
      headers = {
        ...headers,
        Authorization: `Bearer ${get(query, 'values.token', '')}`,
      };
      delete params.token;
    }
    axios
      .get(url, {
        headers,
        params,
      })
      .then(
        (resp: AxiosResponse) =>
          actions.onSuccess({ ...resp.data, addOnData: query.addOnData }),
        (error: any) => actions.onError(error.response)
      );
  }),
  authPostFetch: thunk(async (actions, query: RequestValues<QueryModel>) => {
    actions.onRequest();
    const encodedValues = cryptoJs.AES.encrypt(
      JSON.stringify(query.values),
      process.env.REACT_APP_ENCRYPTION_SECRET as string
    ).toString();
    axios
      .post(
        url,
        {
          payload: encodedValues,
        },
        {
          headers: {
            'Content-Type': CONTENT_TYPE,
            Authorization: `Bearer ${get(query, 'values.token', '')}`,
          },
        }
      )
      .then(
        (resp: AxiosResponse) => {
          actions.onSuccess({ ...resp.data, addOnData: query.addOnData });
        },
        (error: any) => actions.onError(error.response)
      );
  }),
  authGetFetch: thunk(async (actions, query: RequestValues<QueryModel>) => {
    actions.onRequest();
    const encodedValues = cryptoJs.AES.encrypt(
      JSON.stringify(query.values),
      process.env.REACT_APP_ENCRYPTION_SECRET as string
    ).toString();
    axios
      .get(url, {
        params: {
          payload: encodedValues,
        },
        headers: {
          'Content-Type': CONTENT_TYPE,
          Authorization: `Bearer ${get(query, 'values.token', '')}`,
        },
      })
      .then(
        (resp: AxiosResponse) => {
          actions.onSuccess({
            ...resp.data,
            addOnData: query.addOnData,
            encrypted: query.encrypted,
          });
        },
        (error: any) => actions.onError(error.response)
      );
  }),
  registryParameterizedGetFetch: thunk(
    async (actions, query: RequestValues<QueryModel>) => {
      actions.onRequest();
      axios
        .get(`${url}${query.id}`, {
          headers: {
            'Content-Type': CONTENT_TYPE,
          },
        })
        .then(
          (resp: AxiosResponse) =>
            actions.onSuccess({ ...resp.data, addOnData: query.addOnData }),
          (error: any) => actions.onError(error.response)
        );
    }
  ),
  setData: action((state, payload: any) => {
    state.data = payload;
  }),
  clear: action((state) => {
    state.loading = false;
    state.success = false;
    state.data = {
      count: 0,
      data: [],
      vizData: undefined,
    };
    state.errorData = null;
  }),
});
